import React, { Suspense } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";

const Loader = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDir="column"
      gap="18px"
      w="100%"
      h="80vh"
      bg="transparent"
    >
      <Box pos="relative">
        <Box
          pos="absolute"
          inset="-14px"
          borderRadius="50%"
          bg="radial-gradient(circle, rgba(37,99,235,0.25), transparent 70%)"
          filter="blur(10px)"
        />
        <Spinner
          thickness="3px"
          speed="0.7s"
          emptyColor="slate.100"
          color="brand.500"
          size="xl"
        />
      </Box>
      <Text
        fontSize="13px"
        fontWeight={600}
        color="slate.500"
        letterSpacing="wider"
        textTransform="uppercase"
      >
        Loading…
      </Text>
    </Flex>
  );
};

const WithSuspense = (Component) => (props) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} />
  </Suspense>
);

export default WithSuspense;
